import { z } from "zod";
import { Finite, IsoInstant, Symbol_ } from "./primitives";

export const NewsSource = z.enum(["gdelt", "newsdata", "finnhub", "edgar", "federalregister", "rss"]);
export type NewsSource = z.infer<typeof NewsSource>;

export const NewsItem = z.object({
  id: z.string(),
  source: NewsSource,
  title: z.string(),
  url: z.string().url(),
  publishedAt: IsoInstant,
  outlet: z.string().nullable(),
  summary: z.string().nullable(),
  /** Symbols the provider explicitly associated with this item. */
  symbols: z.array(Symbol_).default([]),
});
export type NewsItem = z.infer<typeof NewsItem>;

/**
 * A macro or geopolitical theme extracted from the day's news.
 *
 * Themes are the bridge between "what is happening in the world" and "which
 * tickers it touches". The ticker baskets come from `config/themes.yaml` and
 * are curated by hand; the LLM scores intensity and direction but never
 * invents the mapping, so a hallucinated association cannot move a score.
 */
export const Theme = z.object({
  id: z.string(),
  label: z.string(),
  /** How loudly the news is talking about this, 0..1. */
  intensity: Finite.min(0).max(1),
  /**
   * Sign of the effect on the mapped basket, -1..1. Positive means the news
   * flow is a tailwind for those names, negative a headwind.
   */
  direction: Finite.min(-1).max(1),
  summary: z.string(),
  symbols: z.array(Symbol_),
  /** Article IDs backing the score, so every theme is traceable to sources. */
  evidence: z.array(z.string()),
});
export type Theme = z.infer<typeof Theme>;
